/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';

export type SvuOwnerDocsDelegatePartialUpdateRequest = {} | null | undefined;
export type SvuOwnerDocsDelegatePartialUpdateResponse = any;

export type SvuOwnerDocsDelegatePartialUpdateQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this doc.
   * required: true
   * ```
   */
  id?: number;

  /**
   * ```yaml
   * in: path
   * name: svu_id_subjektu
   * schema:
   *   type: string
   * required: true
   * ```
   */
  svu_id_subjektu?: string;
};

/**
 * PATCH /dmx-server/svu_owner_docs/{id}/delegate/{svu_id_subjektu}/
 *
 * ```yaml
 * operationId: svu_owner_docs_delegate_partial_update
 * tags:
 *   - svu_owner_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     description: No response body
 * ```
 */
export const svuOwnerDocsDelegatePartialUpdateOperation = ({
  id,
  svu_id_subjektu,
  ...rest
}: SvuOwnerDocsDelegatePartialUpdateQuery) =>
  ({
    method: 'PATCH',
    path: `/dmx-server/svu_owner_docs/${id}/delegate/${svu_id_subjektu}/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'PATCH';
    path: string & { _templateUrl: '/dmx-server/svu_owner_docs/{id}/delegate/{svu_id_subjektu}/' };
  };

/**
 * PATCH /dmx-server/svu_owner_docs/{id}/delegate/{svu_id_subjektu}/
 *
 * ```yaml
 * operationId: svu_owner_docs_delegate_partial_update
 * tags:
 *   - svu_owner_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     description: No response body
 * ```
 */
export const svuOwnerDocsDelegatePartialUpdate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: SvuOwnerDocsDelegatePartialUpdateQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<any>> => {
  const operation = svuOwnerDocsDelegatePartialUpdateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'PATCH',
    request,
    onUploadProgress,
    cancelToken,
  );
};
